import './App.css'
import {BrowserRouter} from "react-router-dom";
import AppRoutes from "./routers.tsx";
import ToastProvider from "./components/CustomToast/ToastProvider.tsx";
import {MusicPlayerProvider} from "./providers/musicProvider/music-player-provider.tsx";
import {BASE_NAME} from "./common/constants.ts";
import {UserStorageProvider} from "./providers/userProvider/user-provider.tsx";
import ThemeProvider from "./providers/themeContext/theme-provider.tsx";
import LoadingProvider from "./providers/loadingContext/loading.provider.tsx";

function App() {

    return (
        <BrowserRouter basename={BASE_NAME}>
            <LoadingProvider>
                <MusicPlayerProvider>
                    <UserStorageProvider>
                        <ThemeProvider>
                            <ToastProvider>
                                <AppRoutes/>
                            </ToastProvider>
                        </ThemeProvider>
                    </UserStorageProvider>
                </MusicPlayerProvider>
            </LoadingProvider>
        </BrowserRouter>
    )
}

export default App
